import React from "react";
import "../../assets/css/newnotfound.scss";

const NotFound = () => {
  return (
     <main className="d-flex justify-content-center align-items-center vh-100 text-center">
      <h1 className="display-4 text-muted">404 | Not Found</h1>
    </main>
  );
};

export default NotFound;

